import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold text-accent-700 bg-accent-50 px-3 py-1 rounded-full mb-3">
            精彩内容
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            剧集幕后与深度解读
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            花絮、名场面解析、追剧指南等精彩视频内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaData.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-white group-hover:bg-primary-600 transition-colors">
                    <i className="ri-play-fill text-lg md:text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-medium bg-black/70 text-white rounded backdrop-blur-sm">
                  {item.duration}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>
                  {item.views} 次观看
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}